export default __webpack_public_path__ + "static/media/46_photo.8e151bce.jpg";